// HTTP statuses
export let HttpStatus; // Vinted specific API codes

(function (HttpStatus) {
  HttpStatus[HttpStatus["Ok"] = 200] = "Ok";
  HttpStatus[HttpStatus["Created"] = 201] = "Created";
  HttpStatus[HttpStatus["TemporarilyMoved"] = 302] = "TemporarilyMoved";
  HttpStatus[HttpStatus["MovedPermanently"] = 301] = "MovedPermanently";
  HttpStatus[HttpStatus["TemporaryRedirect"] = 307] = "TemporaryRedirect";
  HttpStatus[HttpStatus["BadRequest"] = 400] = "BadRequest";
  HttpStatus[HttpStatus["Unauthorized"] = 401] = "Unauthorized";
  HttpStatus[HttpStatus["Forbidden"] = 403] = "Forbidden";
  HttpStatus[HttpStatus["NotFound"] = 404] = "NotFound";
  HttpStatus[HttpStatus["RequestTimeout"] = 408] = "RequestTimeout";
  HttpStatus[HttpStatus["PayloadTooLarge"] = 413] = "PayloadTooLarge";
  HttpStatus[HttpStatus["UnprocessableEntity"] = 422] = "UnprocessableEntity";
  HttpStatus[HttpStatus["TooEarly"] = 425] = "TooEarly";
  HttpStatus[HttpStatus["TooManyRequests"] = 429] = "TooManyRequests";
  HttpStatus[HttpStatus["InternalError"] = 500] = "InternalError";
  HttpStatus[HttpStatus["BadGateway"] = 502] = "BadGateway";
  HttpStatus[HttpStatus["ServiceUnavailable"] = 503] = "ServiceUnavailable";
  HttpStatus[HttpStatus["GatewayTimeout"] = 504] = "GatewayTimeout";
})(HttpStatus || (HttpStatus = {}));

export let ResponseCode;

(function (ResponseCode) {
  ResponseCode[ResponseCode["HttpError"] = -200] = "HttpError";
  ResponseCode[ResponseCode["JsError"] = -100] = "JsError";
  ResponseCode[ResponseCode["SessionFromTokenError"] = -99] = "SessionFromTokenError";
  ResponseCode[ResponseCode["Ok"] = 0] = "Ok";
  ResponseCode[ResponseCode["InvalidUser"] = 10] = "InvalidUser";
  ResponseCode[ResponseCode["TransactionInProgress"] = 20] = "TransactionInProgress";
  ResponseCode[ResponseCode["LoginRequired"] = 21] = "LoginRequired";
  ResponseCode[ResponseCode["ValidationError"] = 99] = "ValidationError";
  ResponseCode[ResponseCode["PhotoUploadError"] = 50] = "PhotoUploadError";
  ResponseCode[ResponseCode["PhotoDimensionsTooBig"] = 51] = "PhotoDimensionsTooBig";
  ResponseCode[ResponseCode["PhotoMinimumCountRequired"] = 52] = "PhotoMinimumCountRequired";
  ResponseCode[ResponseCode["InvalidToken"] = 100] = "InvalidToken";
  ResponseCode[ResponseCode["IpBlocked"] = 102] = "IpBlocked";
  ResponseCode[ResponseCode["InvalidProtocol"] = 103] = "InvalidProtocol";
  ResponseCode[ResponseCode["NotFound"] = 104] = "NotFound";
  ResponseCode[ResponseCode["ServerError"] = 105] = "ServerError";
  ResponseCode[ResponseCode["AccessDenied"] = 106] = "AccessDenied";
  ResponseCode[ResponseCode["LockConflict"] = 107] = "LockConflict";
  ResponseCode[ResponseCode["KYCError"] = 108] = "KYCError";
  ResponseCode[ResponseCode["UnavailableCarrierError"] = 110] = "UnavailableCarrierError";
  ResponseCode[ResponseCode["ConfirmEmail"] = 112] = "ConfirmEmail";
  ResponseCode[ResponseCode["UnsupportedFeature"] = 113] = "UnsupportedFeature";
  ResponseCode[ResponseCode["CheckoutError"] = 114] = "CheckoutError";
  ResponseCode[ResponseCode["UserVerificationRequired"] = 115] = "UserVerificationRequired";
  ResponseCode[ResponseCode["Deprecated"] = 116] = "Deprecated";
  ResponseCode[ResponseCode["FollowingTooManyMembers"] = 117] = "FollowingTooManyMembers";
  ResponseCode[ResponseCode["User2FAConfirmation"] = 118] = "User2FAConfirmation";
  ResponseCode[ResponseCode["PaymentProcessingError"] = 119] = "PaymentProcessingError";
  ResponseCode[ResponseCode["LoginWithoutEmail"] = 121] = "LoginWithoutEmail";
  ResponseCode[ResponseCode["Required2FA"] = 122] = "Required2FA";
  ResponseCode[ResponseCode["CantDeliver2FACode"] = 123] = "CantDeliver2FACode";
  ResponseCode[ResponseCode["CreditCardExpired"] = 124] = "CreditCardExpired";
  ResponseCode[ResponseCode["CountryChangeNotAllowed"] = 127] = "CountryChangeNotAllowed";
  ResponseCode[ResponseCode["BusinessAccountConversionInProgress"] = 128] = "BusinessAccountConversionInProgress";
  ResponseCode[ResponseCode["BusinessAccountConversionFailed"] = 129] = "BusinessAccountConversionFailed";
  ResponseCode[ResponseCode["CheckoutChecksumMismatchError"] = 130] = "CheckoutChecksumMismatchError";
  ResponseCode[ResponseCode["IncompleteTaxAddress"] = 131] = "IncompleteTaxAddress";
  ResponseCode[ResponseCode["HarassmentInMessageDetected"] = 134] = "HarassmentInMessageDetected";
  ResponseCode[ResponseCode["InvalidCaptchaToken"] = 135] = "InvalidCaptchaToken";
  ResponseCode[ResponseCode["EmailSharingDetected"] = 136] = "EmailSharingDetected";
  ResponseCode[ResponseCode["EmailVerificationCodeExpired"] = 140] = "EmailVerificationCodeExpired";
  ResponseCode[ResponseCode["ShippingDiscountAlreadyUsed"] = 142] = "ShippingDiscountAlreadyUsed";
  ResponseCode[ResponseCode["PaymentAlreadyProcessed"] = 143] = "PaymentAlreadyProcessed";
  ResponseCode[ResponseCode["TwoFARequired"] = 146] = "TwoFARequired";
  ResponseCode[ResponseCode["FidoVerificationRequired"] = 149] = "FidoVerificationRequired";
})(ResponseCode || (ResponseCode = {}));